import { TableTheme } from "./types";

export const MAP_TABLE_THEME_TO_CLASSNAME = {
  [TableTheme.light]: "bg-white text-gray-950",
  [TableTheme.dark]: "bg-gray-950 text-white",
  [TableTheme.default]:
    "bg-white text-gray-950 dark:bg-gray-950 dark:text-white",
};

export const MAP_TABLE_THEME_TO_HEADER_DIVIDE = {
  [TableTheme.default]: "divide-y divide-black dark:divide-white",
  [TableTheme.light]: "divide-y divide-black",
  [TableTheme.dark]: "divide-y divide-white",
};

export const MAP_TABLE_THEME_TO_BODY_DIVIDE = {
  [TableTheme.default]: "divide-y divide-gray-300 dark:divide-gray-700",
  [TableTheme.light]: "divide-y divide-gray-300",
  [TableTheme.dark]: "divide-y divide-gray-700",
};
